/* eslint-disable no-dupe-keys */
export default {
  withdraw_application: {
    name: '用户提现申请',
    // 属性（一般与对象内容匹配）
    prop: {
      serial_number: '申请编号',
      applied_amount: '申请金额 (元)',
      transfer_amount: '转账金额',
      wechat_refund_amount: '微信退款',
      alipay_refund_amount: '支付宝退款',
      offline_refund_amount: '人工退款',
      status: '审核状态',
      user: '用户',
      user_id: '用户',
      has_refund_fail: '含转账失败',
      latest_withdraw_application_transition: '最后审核人员/信息',
      transferred_at: '转账时间',
      created_at: '申请时间',
      updated_at: '更新时间',
      account_balance: '基础账户余额',
      unpaid_orders_amount: '未支付的订单',
      passed_withdraw_amount: '未转账的提现（不含本申请）',
      can_withdraw_amount: '可用的提现余额',
      freeze_amount: '冻结金额',
      can_withdraw_balance: '可用于提现余额',
      description: '说明',
      mobile_notify: '短信通知',
      miniprogram_notify: '小程序通知',
      payment: '支付方式',
      transfer_type: '转账方式',
      refundable_top_ups: '选择退款记录',
      offline_refund_amount: '人工转账',
      last_review_admin: '最后审核管理员',
      wechat_mini_open_id: '用户微信 openid',
      bank_account_name: '银行卡户名',
      bank_account_number: '银行卡账号',
      bank_name: '开户行',
      service_provider: '运营商',
      internal_remark: '备注'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    // Enum的属性
    statuses: {
      pending: '待审核',
      passed: '待转账',
      transferred: '已转账',
      rejected: '已拒绝',
      failed: '转账失败'
    },
    transitions: {
      pass: '审核通过',
      transfer: '转账',
      reject: '拒绝',
      fail: '转账失败',
      offline: '人工转账'
    },
    // Boolean的属性
    has_refund_fails: { true: '是', false: '否' },
    // 占位提示
    placeholder: {
      search_keyword: '查询申请编号',
      input_description: 'App 可见'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    group_titles: {
      base: '申请信息',
      account: '账户信息',
      transaction_record: '最近交易记录'
    },
    titles: {
      change_state: '审核提示',
      transfer: '转账提示',
      transferred_confirm: '已转账确认',
      transfer_fail: '自动转账失败',
      transferred_success: '转账完成',
      edit_internal_remark: '修改备注',
      split_application: '拆分申请'
    },
    tips: {
      before_passed: '操作前请先确认用户账户余额充足 及 交易记录无异常。审核通过后，充电依然可以使用未转账的金额',
      before_rejected: '拒绝后，需要用户重新申请',
      before_transferred: '提现的钱最终通过充值的原路退回',
      can_withdraw: '余额充足，可以通过审核 / 转账',
      refund_amount_not_enough: '提现金额 < 申请金额，剩余不足的 ￥{0} 请人工转账',
      refund_amount_enough: '提现金额充足',
      fail_transfer_reminder: '有转账失败记录，无法原路退回，请联系技术人员跟进',
      offline_transfer_reminder: '原路退回余额不足，另需要人工转账 ￥{0}',
      transferred_success: '提现完成。提现金额已经全部按充值的原路退回',
      total_amount: '不含已拒绝金额',
      confirm_done_selected: '确认将选中的提现申请标记为已转账？',
      split_application_reminder: '当前提现申请表按充电站拆分后，可拆分为 {0} 个申请单。',
      can_not_split_application_reminder: '当前提现申请结算站数量小于 2 个，无须拆分。'
    },
    // 充值的退款记录
    top_up_refund: {
      payment_type: '支付',
      amount: '金额 (元)',
      refund_recv_account_or_err_msg: '入账账户/失败原因',
      trade_number: '原充值单号',
      status: '转账状态',
      statuses: {
        pending: '待转账',
        fail: '转账失败',
        success: '转账成功'
      }
    },
    labels: {
      wechat_transfer: '微信转账',
      manual_refund: '需人工转账',
      offline_transfer_confirm: '确认人工转账',
      has_refund_fault: '第三方转账失败',
      require_offline_transfer: '无可用原路返回记录',
      total_amount: '总申请金额',
      third_fail_transfer: '第三方转账失败',
      unprocessed_third_fail_transfer: '第三方转账失败(未处理)',
      no_original_return_record: '无原路返回记录',
      unprocessed_no_original_return_record: '无原路返回记录(未处理)'
    },
    list_tabs: {
      all: '全部',
      pending: '待审核',
      passed: '待转账',
      failed: '转账失败',
      transferred: '已转账',
      rejected: '已拒绝'
    },
    btn: {
      batch_transferred_confirm: '确认已转账',
      batch_transfer_confirm: '批量转账确认',
      edit_internal_remark: '修改备注'
    }
  }
}
